import { CloseOutlined } from '@ant-design/icons';
import { Button, Popconfirm } from 'antd';
import React from 'react';

const RemoveFlow = ({ onClick }) => {
  const handleClick = () => {
    onClick();
  };

  return (
    <div>
      <Popconfirm
        title="Remove Flow"
        description="Are you sure you want to remove this flow?"
        onConfirm={handleClick}
        okText="Yes"
        cancelText="No"
        placement="topRight"
      >
        <Button type="text" size="small" icon={<CloseOutlined />} />
      </Popconfirm>
    </div>
  );
};

export default RemoveFlow;
